<template>
	<div class="selectedList">
		<el-row>
			<el-col :span="8">
				<div class="grid-content"><span>任务名称 </span>: {{previewFrom.Name}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content"><span>抽样类型 </span>: {{previewFrom.CategoryName}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content"><span>设备类型 </span>: {{previewFrom.ModalityTypes.join(',')}}</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<div class="grid-content"><span>抽样主体 </span>:
					{{previewFrom.SubjectType | changeSubjectType}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content"><span>扫描类型 </span>:
					{{detailsRulesParameter.ScanTypes==''?'不限':detailsRulesParameter.ScanTypes.join(',')}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content"><span>检查部位 </span>:
					{{detailsRulesParameter.BodyParts==''?'不限':detailsRulesParameter.BodyParts.join(',')}}</div>
			</el-col>
			<!-- <el-col :span="8">
				<div class="grid-content"><span>病例样本 </span>: <span v-if="detailsRulesParameter.IsPositives==''">不限</span><span
					 v-else>{{detailsRulesParameter.IsPositives | changePositives}}</span></div>
			</el-col> -->
		</el-row>
		<el-row>
			<el-col :span="8">
				<div class="grid-content"><span>抽样时间 </span>: {{previewFrom.StartDate | getCurrentDate}} <span v-if="previewFrom.EndDate!=''"> ~ 
					{{previewFrom.EndDate | getCurrentDate}}</span></div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content"><span>完成时间 </span>: <span v-if="previewFrom.PlannedCompleteDt==''">不限</span><span
					 v-else>{{previewFrom.PlannedCompleteDt | getCurrentDate}}</span></div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content"><span>评审人数 </span>: {{previewFrom.QCTimes}}人/份</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="8">
				<div class="grid-content"><span>评分方案 </span>: {{previewFrom.QCPlanName}}</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
		export default {
			name:'detailInformation',
			props: ['previewFrom', 'detailsRulesParameter'],
			data() {
				return {
				}
			},
			filters: {
				changeSubjectType:function(value){
					return (
						{
							'': '不限',
							'3': '影像技师',
							'4': '诊断医生',
							'2': '审核医生',
						}[value] || '不限'
					);
				},
				changePositives: function(arr) {
					let newarr = []
					arr.forEach((item, index) => {
						if (item == 1) {
							newarr[index] = '阳性'
						}
						if (item == 2) {
							newarr[index] = '阴性'
						}
						if (item == 0) {
							newarr[index] = '未知'
						}
					})
					return newarr.join(',')
				},
				getCurrentDate(datas) {
					if (datas) {
						let newdate = new Date(datas)
						let year = newdate.getFullYear(); //得到年份
						let month = newdate.getMonth() + 1; //得到月份
						let date = newdate.getDate(); //得到日期
						month = month < 10 ? '0' + month : month;
						date = date < 10 ? '0' + date : date;
						return year + '-' + month + '-' + date
					}
				},
			}
		}
</script>

<style>

</style>
